import React from 'react';
export function Guarantee() {
  return <section className="py-8 px-4 bg-soft-rose" data-id="element-61">
      <div className="max-w-3xl mx-auto bg-white rounded-3xl p-6 md:p-8 shadow-soft text-center border-4 border-cream relative overflow-hidden" data-id="element-62">
        <div className="absolute -top-10 -right-10 text-9xl opacity-5" data-id="element-63">🛡️</div>

        <div className="text-5xl mb-4" data-id="element-64">🛡️</div>
        <h2 className="text-2xl md:text-3xl font-bold mb-2" data-id="element-65">
          GARANTÍA DE 7 DÍAS
        </h2>
        <h3 className="text-lg md:text-xl text-deep-rose italic mb-6" data-id="element-66">
          "Sentí el Primer Movimiento o te Devuelvo el Dinero"
        </h3>

        <div className="space-y-4 text-base text-warm-brown-dark leading-relaxed text-left" data-id="element-67">
          <p data-id="element-68">
            Sé que cuando algo nuevo llega a nuestras manos, hay una voz pequeña
            que pregunta: <em data-id="element-69">"¿Y si no es para mí?"</em>
          </p>
          <p data-id="element-70">Por eso quiero que entres en este proceso sin miedo.</p>
          <p data-id="element-71">
            Descargá los dos Tomos. Hacé el primer ritual. Leé el primer
            capítulo. Si en 7 días no sentiste ni un pequeño movimiento interno
            —una emoción, una comprensión, una sensación en el cuerpo— te
            devuelvo el{' '}
            <strong data-id="element-72">100% de tu inversión sin preguntas y sin vueltas.</strong>
          </p>
          <p className="font-bold text-center text-lg mt-6 text-deep-rose" data-id="element-73">
            Yo confío en este método porque lo viví. Y confío en vos porque ya
            llegaste hasta acá.
          </p>
        </div>
      </div>
    </section>;
}